<div class="page-tab">
  <!-- A page designed before the template is still at this address until it is converted (#262). -->
  <div *ngIf="designedPage" class="designed">
    <strong>Designed before the template.</strong>
    This address still has its own page; the website keeps showing that one until it is converted to the template plus
    blocks inserted here.
    <button *ngIf="tab.canConvert" pButton type="button" class="p-button-sm p-button-outlined mt-2 convert-page" icon="pi pi-sync"
            label="Convert this page" [loading]="saving" (click)="convert()"></button>
  </div>

  <app-suburb-page-settings [form]="form" [fromMap]="fromMap" [regionOptions]="regionOptions" [regionNote]="regionNote"
                            [pathPrefix]="pathPrefix" [renamingFrom]="renamingFrom" [slugClash]="slugClash" (nameInput)="onNameInput()"></app-suburb-page-settings>

  <app-suburb-page-content [form]="form" [draftsWaiting]="fromMap ? draftsWaiting : 0" [faqOptions]="faqOptions" [heroPreview]="heroPreview"
                           (openDrafts)="openDrafts()" (uploadHero)="uploadHero()" (removeHero)="removeHero()"></app-suburb-page-content>

  <section class="structure">
    <div class="lbl">Structure <span class="meta-inline">the {{ subRegion ? 'Sub-region' : 'Suburb' }} template, with this page's own blocks</span></div>
    <app-page-outline [rows]="rows" [editable]="!editing" [pageName]="form.get('name')?.value" (add)="addAt($event)" (edit)="edit($event)"
                      (move)="move($event)" (remove)="remove($event)"></app-page-outline>
    <app-suburb-block-editor *ngIf="editing" [section]="editing.section" [isNew]="editing.after !== null" [pageName]="form.get('name')?.value"
                             [previewRequest]="blockPreview" (done)="editDone($event)" (cancel)="editing = null"></app-suburb-block-editor>
  </section>

  <!-- Sticky action bar, the same shape as the Page editor's. -->
  <div class="actions">
    <button pButton type="button" label="Preview page" icon="pi pi-eye" class="p-button-text page-preview" (click)="preview.show()"
            pTooltip="The whole page as the website draws it, with what you have here" tooltipPosition="top"></button>
    <button pButton type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
    <button pButton type="button" label="Save" icon="pi pi-check" class="p-button-outlined page-save" [loading]="saving" (click)="onSave()"></button>
    <button pButton type="button" [label]="live ? 'Publish changes' : 'Publish'" icon="pi pi-cloud-upload" class="p-button-success suburb-publish"
            [disabled]="saving" (click)="onSave('publish')" pTooltip="Save, then put this page on the website preview" tooltipPosition="top"></button>
    <button *ngIf="live" pButton type="button" label="Un-publish" icon="pi pi-eye-slash" class="p-button-outlined p-button-danger suburb-unpublish"
            [disabled]="saving" (click)="unpublish()"></button>
  </div>
</div>
